// //frontend/src/pages/agent/AgentComplaintDetailsPage.js

// import React, { useState, useEffect, useContext, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import AuthContext from '../../context/AuthContext';
// import toast from 'react-hot-toast';
// import Modal from '../../components/ui/Modal'; // Path corrected
// import { Button, Box, CircularProgress, Card, CardContent, Typography, Divider, IconButton } from '@mui/material'; // <-- MUI Components
// import { FiMap, FiPlayCircle, FiStopCircle} from 'react-icons/fi'; // Icon for Navigation

// const API_BASE_URL = 'https://smart-eseva-backend.onrender.com/api/v1';

// // --- Verification Modal Component (Nested) ---
// const VerificationModal = ({ complaintId, ticketId, onVerifySuccess, onModalClose }) => {
//     const { auth } = useContext(AuthContext);
//     const [code, setCode] = useState('');
//     const [verifying, setVerifying] = useState(false);

//     const handleVerification = async (e) => {
//         e.preventDefault();
//         if (code.length !== 6) {
//             toast.error("Please enter the 6-digit code.");
//             return;
//         }
//         setVerifying(true);

//         try {
//             const config = { headers: { 'Authorization': `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };
//             // PUT API call to verify and resolve
//             const response = await axios.put(`${API_BASE_URL}/agent/verify-resolve/${complaintId}`,
//                 { code: code }, // VerificationRequestDTO use hoga
//                 config
//             );

//             toast.success(`Complaint ${ticketId} resolved and closed!`);
//             onVerifySuccess(response.data); // Update state in parent component

//         } catch (error) {
//             console.error("Verification failed:", error);
//             const errorMessage = error.response?.data || "Invalid code or verification failed.";
//             toast.error(errorMessage);
//         } finally {
//             setVerifying(false);
//         }
//     };

//     return (
//         <Modal isOpen={true} onClose={onModalClose} title={`Final Verification: ${ticketId}`} hideConfirmButton={true}>
//             <form onSubmit={handleVerification}>
//                 <p>Please get the 6-digit verification code from the citizen to resolve this complaint.</p>
//                 <input
//                     type="text"
//                     value={code}
//                     onChange={(e) => setCode(e.target.value)}
//                     maxLength="6"
//                     placeholder="Enter 6-digit Code"
//                     required
//                     disabled={verifying}
//                     style={{ padding: '10px', width: '100%', marginBottom: '15px', fontSize: '1.2em', textAlign: 'center' }}
//                 />
//                 <button type="submit" disabled={verifying} style={buttonStyle('resolved')}>
//                     {verifying ? 'Verifying...' : 'VERIFY & RESOLVE'}
//                 </button>
//             </form>
//         </Modal>
//     );
// };
// // --- End of Verification Modal Component ---


// const AgentComplaintDetailsPage = () => {
//     const { auth } = useContext(AuthContext);
//     const { id } = useParams();
//     const [complaint, setComplaint] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [statusUpdating, setStatusUpdating] = useState(false);

//     const [currentLocation, setCurrentLocation] = useState(null); // Live location state
//     const [isVerificationModalOpen, setVerificationModalOpen] = useState(false); // NEW STATE for Modal
//     const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
//     const [isTracking, setIsTracking] = useState(false); // Kya tracking chalu hai?
//     const watchIdRef = useRef(null); // watchPosition ki
//     const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };



//     // --- 1. Fetch Complaint Details (Agent API) ---
//     useEffect(() => {
//         const fetchDetails = async () => {
//             if (!auth.token || !id) { setLoading(false); return; }
//             try {
//                 const response = await axios.get(`${API_BASE_URL}/agent/complaints/${id}`, config);
//                 setComplaint(response.data);
//             } catch (error) {
//                 console.error("Failed to fetch complaint details:", error);
//                 toast.error(`Error loading complaint ${id}.`);
//             } finally { setLoading(false); }
//         };
//         fetchDetails();
//     }, [auth.token, id]);

//     // --- 2. Live Location Fetcher ---
//     useEffect(() => {
//         if ("geolocation" in navigator) {
//             // Location fetch karne ki koshish karo
//             navigator.geolocation.getCurrentPosition(
//                 (position) => {
//                     // Success: Location mil gayi to state mein save kar lo
//                     setCurrentLocation({
//                         lat: position.coords.latitude,
//                         lng: position.coords.longitude
//                     });
//                     toast.success("Live location fetched!");
//                 },
//                 (error) => {
//                     // Error: Agar location nahi mili
//                     console.error("Error getting live location:", error);
//                     setCurrentLocation(false); // State mein false set kar do
//                     toast.error("Could not get your location. Please check browser permission and move to an open area.");
//                 },
//                 {
//                     enableHighAccuracy: true,
//                     timeout: 15000, // Timeout badha kar 15 seconds kar diya
//                     maximumAge: 0
//                 }
//             );
//         } else {
//             // Agar browser mein location feature hi nahi hai
//             setCurrentLocation(false);
//             toast.error("Geolocation is not supported by this browser.");
//         }
//     }, []); // Yeh useEffect sirf component load hone par ek baar chalega

//     // --- 3. Navigation Handler (Combines location check & URL fix) ---
//     const handleNavigate = () => {
//         if (!complaint || !complaint.latitude || !complaint.longitude) {
//             toast.error("Complaint location is missing.");
//             return;
//         }

//         const destination = `${complaint.latitude},${complaint.longitude}`;
//         let navigationUrl;

//         // Check karo ki state mein live location hai ya nahi
//         if (currentLocation && currentLocation.lat && currentLocation.lng) {
//             const source = `${currentLocation.lat},${currentLocation.lng}`;

//             // --- YEH HAI 100% SAHI GOOGLE MAPS URL ---
//             navigationUrl = `https://www.google.com/maps/dir/?api=1&origin=${source}&destination=${destination}`;

//             window.open(navigationUrl, "_blank"); // Naye tab mein URL khol do

//         } else {
//             // Agar live location nahi mili to user ko batao
//             toast.error("Your live location is not available. Please try again after some time.");
//             // Fallback: Sirf complaint ki location map par dikha do
//             navigationUrl = `http://googleusercontent.com/maps.google.com/search/?api=1&query=${destination}`;

//         }
//         window.open(navigationUrl, "_blank");
//     };

//     // --- 4. Code Generation & Status Change Handler ---
//     const handleCodeGeneration = async (currentStatus) => {

//         setConfirmModalOpen(true);
//     };

//     const updateLocationAPI = async (latitude, longitude) => {
//         if (!auth.token) return;
//         try {
//             const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };
//             await axios.put(`${API_BASE_URL}/agent/location`, { latitude, longitude }, config);
//             console.log('Location updated:', latitude, longitude); // Log kar sakte hain
//         } catch (error) {
//             console.error("Failed to update location via API:", error);
//             // Yahan toast dikha sakte hain agar zaroori ho
//         }
//     };

//     // Function jo location tracking shuru karega
//     const startTracking = () => {
//         if (!("geolocation" in navigator)) {
//             toast.error("Geolocation is not supported by your browser.");
//             return;
//         }

//         setIsTracking(true);
//         toast.success("Live location tracking started!");

//         // watchPosition ko call karo aur ID save karo
//         watchIdRef.current = navigator.geolocation.watchPosition(
//             (position) => {
//                 // Har baar nayi location milne par API call karo
//                 const { latitude, longitude } = position.coords;
//                 updateLocationAPI(latitude, longitude);
//             },
//             (error) => {
//                 // Agar location fetch karne mein error aaye
//                 console.error("Error watching position:", error);
//                 toast.error(`Location tracking error: ${error.message}`);
//                 stopTracking(); // Tracking band kar do
//             },
//             {
//                 enableHighAccuracy: true, // Best possible location
//                 timeout: 10000,          // 10 second timeout
//                 maximumAge: 0,           // Hamesha nayi location chahiye
//                 distanceFilter: 10       // Location tabhi update hogi jab agent 10 meter move karega (optional)
//             }
//         );
//     };

//     // Function jo location tracking band karega
//     const stopTracking = () => {
//         if (watchIdRef.current !== null) {
//             navigator.geolocation.clearWatch(watchIdRef.current);
//             watchIdRef.current = null; // ID ko reset karo
//             setIsTracking(false);
//             toast.info("Live location tracking stopped.");
//             console.log("Tracking stopped.");
//         }
//     };

//     useEffect(() => {
//         // Yeh function tab chalega jab component screen se hatega
//         return () => {
//             stopTracking();
//         };
//     }, []);

//     // --- NAYE FUNCTIONS END ---

//     const confirmAndGenerateCode = async () => {
//         if (statusUpdating) return;
//         setStatusUpdating(true);
//         setConfirmModalOpen(false); // Naye modal ko band karo

//         try {
//             // Yeh aapka purana logic hai
//             const response = await axios.get(`${API_BASE_URL}/agent/generate-code/${complaint.id}`, config);
//             toast.success("Verification code has been sent to the citizen successfully!");
//             setVerificationModalOpen(true); // Purana code entry modal kholo

//         } catch (error) {
//             console.error("Code generation failed:", error);
//             const errorMessage = error.response?.data || "Error starting verification process.";
//             toast.error(errorMessage);
//         } finally {
//             setStatusUpdating(false);
//         }
//     };


//     // Final handler after successful verification
//     const handleVerificationSuccess = (updatedComplaint) => {
//         setComplaint(updatedComplaint); // UI update karein
//         setVerificationModalOpen(false);
//         stopTracking();
//     };

//     // --- Render Logic ---
//     if (loading) return <div>Loading Complaint Details...</div>;
//     if (!complaint) return <div>Complaint not found or unauthorized access.</div>;

//     const isResolved = complaint.status === 'Resolved';
//     const isInProgress = complaint.status === 'In-Progress';
//     // const isReadyToStart = complaint.status === 'New' || complaint.status === 'Assigned';
//     const isAssignedOrNew = complaint.status === 'Assigned' || complaint.status === 'New';

//     return (
//         <div style={{ padding: '20px' }}>
//             <h1>Complaint Details: {complaint.ticketId}</h1>
//             <div style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>
//                 <p><strong>Category:</strong> {complaint.category}</p>
//                 <p><strong>Description:</strong> {complaint.description}</p>
//                 <p><strong>Location:</strong> {complaint.location} (Landmark: {complaint.landmark})</p>
//                 <p><strong>Citizen Email:</strong> {complaint.citizen?.email}</p>

//                 {/* Navigation Button */}
//                 <div style={{ marginTop: '15px', marginBottom: '15px' }}>
//                     <button
//                         onClick={handleNavigate}
//                         disabled={!complaint.latitude}
//                         style={{ ...buttonStyle('navigate'), backgroundColor: '#007bff', color: 'white' }}
//                     >
//                         <FiMap style={{ marginRight: '5px' }} /> Navigate from Live Location
//                     </button>
//                     {currentLocation === false && (
//                         <p style={{ color: 'red', fontSize: '0.9em' }}>Could not fetch your live location. Map will show complaint destination only.</p>
//                     )}
//                     {(complaint.status === 'Assigned' || complaint.status === 'In-Progress') && (
//                         isTracking ? (
//                             // Agar tracking chalu hai, to Stop button dikhao
//                             <Button 
//                                 variant="contained" 
//                                 color="error" 
//                                 onClick={stopTracking}
//                                 startIcon={<FiStopCircle />}
//                             >
//                                 Stop Tracking
//                             </Button>
//                         ) : (
//                             // Agar tracking band hai, to Start button dikhao
//                             <Button 
//                                 variant="contained" 
//                                 color="success" 
//                                 onClick={startTracking}
//                                 startIcon={<FiPlayCircle />}
//                             >
//                                 Start Journey
//                             </Button>
//                         )
//                     )}
//                     {/* --- NAYA BUTTON LOGIC END --- */}

//                     {/* ... error message ... */}
                    
//                 </div>

//                 <hr />
//                 <p style={{ fontWeight: 'bold', color: isResolved ? 'green' : 'red' }}>Current Status: {complaint.status}</p>

//                 {/* Status Update Buttons */}
//                 <div style={{ marginTop: '20px' }}>
//                     {/* Button A: Start Work / Get Code
//                     {isReadyToStart && (
//                         <button onClick={() => handleCodeGeneration(complaint.status)} disabled={statusUpdating} style={buttonStyle('progress')}>
//                             {statusUpdating ? 'Starting Work...' : 'START WORK & GET CODE'}
//                         </button>
//                     )} */}

//                     {/* Button B: Mark as Resolved (Verification Modal open karein) */}

//                     {(isInProgress || isAssignedOrNew) && !isResolved && (
//                         <button
//                             // FIX: handleCodeGeneration ko call karein on click
//                             onClick={() => handleCodeGeneration(complaint.status)}
//                             disabled={statusUpdating}
//                             style={buttonStyle('resolved')}
//                         >
//                             {statusUpdating ? 'Generating Code...' : 'MARK AS RESOLVED (Get Code)'}
//                         </button>
//                     )}
//                     {/* {isInProgress && (
//                         <button onClick={() => setVerificationModalOpen(true)} disabled={statusUpdating} style={buttonStyle('resolved')}>
//                             Mark as Resolved
//                         </button>
//                     )} */}
//                 </div>
//             </div>

//             {/* --- Verification Modal Render --- */}
//             {isVerificationModalOpen && complaint && (
//                 <VerificationModal
//                     complaintId={complaint.id}
//                     ticketId={complaint.ticketId}
//                     onVerifySuccess={handleVerificationSuccess}
//                     onModalClose={() => setVerificationModalOpen(false)}
//                 />
//             )}

//             {isConfirmModalOpen && (
//                 <Modal
//                     isOpen={true}
//                     onClose={() => setConfirmModalOpen(false)}
//                     title="Confirm Action"
//                     // Naye modal ke confirm par naya function call karo
//                     onConfirm={confirmAndGenerateCode}
//                     confirmText="Yes, Proceed"
//                     cancelText="No, Cancel"
//                 >
//                     <p>Are you sure you have reached the location and are ready to mark this complaint as resolved? This will generate the Citizen Verification Code.</p>
//                 </Modal>
//             )}
//         </div>
//     );
// };

// // Inline styling for buttons
// const buttonStyle = (type) => ({
//     padding: '10px 15px',
//     marginRight: '10px',
//     backgroundColor: type === 'progress' ? '#ffc107' : type === 'resolved' ? '#28a745' : '#ccc',
//     color: type === 'progress' ? '#333' : 'white',
//     border: 'none',
//     borderRadius: '5px',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center'
// });

// export default AgentComplaintDetailsPage;






// import React, { useState, useEffect, useContext, useRef } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import AuthContext from '../../context/AuthContext';
// import toast from 'react-hot-toast';
// import Modal from '../../components/ui/Modal'; 
// import { 
//     Box, Button, Typography, Card, CardContent, Grid, Chip, 
//     Container, Paper, Divider, IconButton, CircularProgress 
// } from '@mui/material';
// import { 
//     Map, PlayCircle, StopCircle, CheckCircle, Navigation, 
//     Phone, Email, Person, LocationOn 
// } from '@mui/icons-material';

// // --- WebSocket Imports ---
// import SockJS from 'sockjs-client';
// import { Client } from '@stomp/stompjs';

// const API_BASE_URL = 'https://smart-eseva-backend.onrender.com/api/v1';
// const WS_URL = 'https://smart-eseva-backend.onrender.com/ws';

// // --- 1. Verification Modal (Styled) ---
// const VerificationModal = ({ ticketId, onVerifySuccess, onModalClose, complaintId }) => {
//     const { auth } = useContext(AuthContext);
//     const [code, setCode] = useState('');
//     const [verifying, setVerifying] = useState(false);

//     const handleVerification = async (e) => {
//         e.preventDefault();
//         if (code.length !== 6) {
//             toast.error("Please enter the 6-digit code.");
//             return;
//         }
//         setVerifying(true);
//         try {
//             const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };
//             const response = await axios.put(`${API_BASE_URL}/agent/verify-resolve/${complaintId}`, { code }, config);
            
//             toast.success(`Ticket ${ticketId} Closed Successfully!`);
//             onVerifySuccess(response.data); 
//         } catch (error) {
//             toast.error(error.response?.data || "Verification failed.");
//         } finally {
//             setVerifying(false);
//         }
//     };

//     return (
//         <Modal isOpen={true} onClose={onModalClose} title="Citizen Verification" hideConfirmButton={true}>
//             <Box textAlign="center" p={2}>
//                 <Typography variant="body1" mb={2}>
//                     Ask the citizen for the <strong>6-digit OTP</strong> sent to their app.
//                 </Typography>
//                 <form onSubmit={handleVerification}>
//                     <input
//                         type="text"
//                         value={code}
//                         onChange={(e) => setCode(e.target.value)}
//                         maxLength="6"
//                         placeholder="• • • • • •"
//                         required
//                         disabled={verifying}
//                         style={{ 
//                             padding: '15px', width: '80%', fontSize: '1.5em', textAlign: 'center', 
//                             letterSpacing: '8px', border: '2px solid #ddd', borderRadius: '10px', marginBottom: '20px' 
//                         }}
//                     />
//                     <Button 
//                         type="submit" 
//                         variant="contained" 
//                         color="success" 
//                         fullWidth 
//                         size="large"
//                         disabled={verifying}
//                         startIcon={<CheckCircle />}
//                     >
//                         {verifying ? 'Verifying...' : 'VERIFY & CLOSE JOB'}
//                     </Button>
//                 </form>
//             </Box>
//         </Modal>
//     );
// };

// // --- 2. Main Page Component ---
// const AgentComplaintDetailsPage = () => {
//     const { auth } = useContext(AuthContext);
//     const { id } = useParams();
//     const navigate = useNavigate();
    
//     const [complaint, setComplaint] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [currentLocation, setCurrentLocation] = useState(null);
    
//     // UI States
//     const [isVerificationModalOpen, setVerificationModalOpen] = useState(false);
//     const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);
//     const [statusUpdating, setStatusUpdating] = useState(false);

//     // Tracking States
//     const [isTracking, setIsTracking] = useState(false);
//     const watchIdRef = useRef(null);
//     const stompClientRef = useRef(null);

//     const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };

//     // --- A. Fetch Data ---
//     useEffect(() => {
//         const fetchDetails = async () => {
//             if (!auth.token || !id) return;
//             try {
//                 const response = await axios.get(`${API_BASE_URL}/agent/complaints/${id}`, config);
//                 setComplaint(response.data);
//             } catch (error) {
//                 toast.error("Failed to load details.");
//                 navigate('/agent/dashboard');
//             } finally { setLoading(false); }
//         };
//         fetchDetails();

//         // One-time location fetch for Navigation
//         if ("geolocation" in navigator) {
//             navigator.geolocation.getCurrentPosition(
//                 (pos) => setCurrentLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
//                 (err) => console.warn("Location error", err),
//                 { enableHighAccuracy: true }
//             );
//         }
//     }, [id, auth.token]);

//     // --- B. Navigation Logic ---
//     const handleNavigate = () => {
//         if (!complaint?.latitude) return toast.error("Location missing.");
//         const dest = `${complaint.latitude},${complaint.longitude}`;
//         const src = currentLocation ? `${currentLocation.lat},${currentLocation.lng}` : '';
//         const url = `https://www.google.com/maps/dir/?api=1&origin=${src}&destination=${dest}&travelmode=driving`;
//         window.open(url, "_blank");
//     };

//     // --- C. Live Tracking Logic (WebSocket) ---
//     const startTracking = () => {
//         if (!("geolocation" in navigator)) return toast.error("GPS not supported.");
        
//         const client = new Client({
//             webSocketFactory: () => new SockJS(WS_URL),
//             reconnectDelay: 5000,
//             onConnect: () => {
//                 setIsTracking(true);
//                 toast.success("Journey Started - Live Tracking ON");
                
//                 watchIdRef.current = navigator.geolocation.watchPosition(
//                     (pos) => {
//                         const { latitude, longitude } = pos.coords;
//                         // Send to WebSocket
//                         client.publish({
//                             destination: `/topic/complaint/${complaint.id}/location`,
//                             body: JSON.stringify({ lat: latitude, lng: longitude })
//                         });
//                         // Optional: DB Update (Throttled)
//                         // updateLocationAPI(latitude, longitude); 
//                     },
//                     (err) => console.error(err),
//                     { enableHighAccuracy: true }
//                 );
//             }
//         });
//         client.activate();
//         stompClientRef.current = client;
//     };

//     // BUG FIX: Added 'showToast' param to prevent crash on unmount
//     const stopTracking = (showToast = true) => {
//         if (watchIdRef.current) {
//             navigator.geolocation.clearWatch(watchIdRef.current);
//             watchIdRef.current = null;
//         }
//         if (stompClientRef.current) {
//             stompClientRef.current.deactivate();
//             stompClientRef.current = null;
//         }
//         if (isTracking) {
//             setIsTracking(false);
//             if (showToast) toast.success("Journey Ended"); // Changed from toast.info to toast.success
//         }
//     };

//     // Auto-stop tracking when leaving page
//     useEffect(() => {
//         return () => stopTracking(false);
//     }, [isTracking]);


//     // --- D. Resolve Flow ---
//     const initiateResolve = () => setConfirmModalOpen(true);

//     const generateCodeAndOpenModal = async () => {
//         setConfirmModalOpen(false);
//         setStatusUpdating(true);
//         try {
//             await axios.get(`${API_BASE_URL}/agent/generate-code/${complaint.id}`, config);
//             toast.success("OTP sent to Citizen!");
//             setVerificationModalOpen(true);
//         } catch (error) {
//             toast.error("Failed to generate OTP.");
//         } finally {
//             setStatusUpdating(false);
//         }
//     };

//     const handleSuccess = (updatedComplaint) => {
//         setComplaint(updatedComplaint);
//         setVerificationModalOpen(false);
//         stopTracking(false);
//     };

//     if (loading) return <Box p={4} textAlign="center"><CircularProgress /></Box>;
//     if (!complaint) return <Typography>No Data</Typography>;

//     const isResolved = complaint.status === 'Resolved';
//     const getStatusColor = () => isResolved ? '#2e7d32' : '#ed6c02';

//     return (
//         <Container maxWidth="md" sx={{ mt: 4, mb: 8 }}>
            
//             {/* 1. Header Card */}
//             <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: '12px', borderLeft: `6px solid ${getStatusColor()}` }}>
//                 <Grid container justifyContent="space-between" alignItems="center">
//                     <Grid item>
//                         <Chip label={complaint.ticketId} sx={{ fontWeight: 'bold', mb: 1 }} />
//                         <Typography variant="h5" fontWeight="bold">{complaint.category}</Typography>
//                     </Grid>
//                     <Grid item>
//                         <Typography variant="h6" sx={{ color: getStatusColor(), fontWeight: 'bold' }}>
//                             {complaint.status.toUpperCase()}
//                         </Typography>
//                     </Grid>
//                 </Grid>
//             </Paper>

//             <Grid container spacing={3}>
//                 {/* 2. Details Column */}
//                 <Grid item xs={12} md={7}>
//                     <Card sx={{ borderRadius: '12px', height: '100%' }}>
//                         <CardContent>
//                             <Typography variant="h6" gutterBottom><LocationOn /> Location Details</Typography>
//                             <Divider sx={{ mb: 2 }} />
//                             <Typography variant="body1" paragraph>
//                                 {complaint.location}
//                             </Typography>
//                             <Typography variant="body2" color="text.secondary">
//                                 <strong>Landmark:</strong> {complaint.landmark || 'N/A'}
//                             </Typography>
                            
//                             <Box mt={3}>
//                                 <Typography variant="h6" gutterBottom><Person /> Citizen Details</Typography>
//                                 <Divider sx={{ mb: 2 }} />
//                                 <Box display="flex" alignItems="center" gap={1} mb={1}>
//                                     <Email color="action" /> 
//                                     <Typography>{complaint.citizen?.email}</Typography>
//                                 </Box>
//                                 <Box display="flex" alignItems="center" gap={1}>
//                                     <Phone color="action" />
//                                     {/* Click to Call */}
//                                     <a href={`tel:${complaint.citizen?.mobileNumber}`} style={{ textDecoration: 'none', color: '#007bff' }}>
//                                         {complaint.citizen?.mobileNumber || 'N/A'}
//                                     </a>
//                                 </Box>
//                             </Box>
//                         </CardContent>
//                     </Card>
//                 </Grid>

//                 {/* 3. Action Column */}
//                 <Grid item xs={12} md={5}>
//                     <Card sx={{ borderRadius: '12px', height: '100%', bgcolor: '#f8f9fa' }}>
//                         <CardContent>
//                             <Typography variant="h6" gutterBottom>Agent Actions</Typography>
//                             <Divider sx={{ mb: 2 }} />

//                             {/* Navigation */}
//                             <Button 
//                                 variant="outlined" 
//                                 fullWidth 
//                                 startIcon={<Navigation />} 
//                                 onClick={handleNavigate}
//                                 sx={{ mb: 2, py: 1.5 }}
//                             >
//                                 Open in Google Maps
//                             </Button>

//                             {/* Tracking Controls */}
//                             {!isResolved && (
//                                 isTracking ? (
//                                     <Button 
//                                         variant="contained" 
//                                         color="error" 
//                                         fullWidth 
//                                         startIcon={<StopCircle />} 
//                                         onClick={() => stopTracking(true)}
//                                         sx={{ mb: 2, py: 1.5 }}
//                                     >
//                                         Stop Tracking
//                                     </Button>
//                                 ) : (
//                                     <Button 
//                                         variant="contained" 
//                                         color="primary" 
//                                         fullWidth 
//                                         startIcon={<PlayCircle />} 
//                                         onClick={startTracking}
//                                         sx={{ mb: 2, py: 1.5 }}
//                                     >
//                                         Start Journey
//                                     </Button>
//                                 )
//                             )}

//                             {/* Resolve Button */}
//                             {!isResolved && (
//                                 <Button 
//                                     variant="contained" 
//                                     color="success" 
//                                     fullWidth 
//                                     size="large"
//                                     onClick={initiateResolve}
//                                     disabled={statusUpdating}
//                                     sx={{ mt: 2, py: 1.5, fontWeight: 'bold' }}
//                                 >
//                                     MARK AS RESOLVED
//                                 </Button>
//                             )}

//                             {isResolved && (
//                                 <Box textAlign="center" mt={2} p={2} bgcolor="#e8f5e9" borderRadius="8px">
//                                     <CheckCircle color="success" sx={{ fontSize: 40 }} />
//                                     <Typography variant="subtitle1" fontWeight="bold" color="success.main">
//                                         Job Completed
//                                     </Typography>
//                                 </Box>
//                             )}
//                         </CardContent>
//                     </Card>
//                 </Grid>
//             </Grid>

//             {/* Modals */}
//             {isVerificationModalOpen && (
//                 <VerificationModal 
//                     complaintId={complaint.id} 
//                     ticketId={complaint.ticketId}
//                     onVerifySuccess={handleSuccess} 
//                     onModalClose={() => setVerificationModalOpen(false)} 
//                 />
//             )}

//             {isConfirmModalOpen && (
//                 <Modal isOpen={true} onClose={() => setConfirmModalOpen(false)} title="Confirm Arrival" onConfirm={generateCodeAndOpenModal} confirmText="Yes, Generate OTP">
//                     <Typography>Have you reached the location and fixed the issue?</Typography>
//                 </Modal>
//             )}
//         </Container>
//     );
// };

// export default AgentComplaintDetailsPage;





//frontend/src/pages/agent/AgentComplaintDetailsPage.js



import React, { useState, useEffect, useContext, useRef } from 'react';

import { useParams } from 'react-router-dom';

import axios from 'axios';

import AuthContext from '../../context/AuthContext';

import toast from 'react-hot-toast';

import Modal from '../../components/ui/Modal'; // Path corrected

import { Button, Box, CircularProgress, Card, CardContent, Typography, Divider, IconButton } from '@mui/material'; // <-- MUI Components

import { FiMap, FiPlayCircle, FiStopCircle } from 'react-icons/fi'; // Icon for Navigation



const API_BASE_URL = 'https://smart-eseva-backend.onrender.com/api/v1';



// --- Verification Modal Component (Nested) ---

const VerificationModal = ({ complaintId, ticketId, onVerifySuccess, onModalClose }) => {

    const { auth } = useContext(AuthContext);

    const [code, setCode] = useState('');

    const [verifying, setVerifying] = useState(false);



    const handleVerification = async (e) => {

        e.preventDefault();

        if (code.length !== 6) {

            toast.error("Please enter the 6-digit code.");

            return;

        }

        setVerifying(true);



        try {

            const config = { headers: { 'Authorization': `Bearer ${auth.token}`, 'Content-Type': 'application/json' } };

            // PUT API call to verify and resolve

            const response = await axios.put(`${API_BASE_URL}/agent/verify-resolve/${complaintId}`,

                { code: code }, // VerificationRequestDTO use hoga

                config

            );



            toast.success(`Complaint ${ticketId} resolved and closed!`);

            onVerifySuccess(response.data); // Update state in parent component



        } catch (error) {

            console.error("Verification failed:", error);

            const errorMessage = error.response?.data || "Invalid code or verification failed.";

            toast.error(errorMessage);

        } finally {

            setVerifying(false);

        }

    };



    return (

        <Modal isOpen={true} onClose={onModalClose} title={`Final Verification: ${ticketId}`} hideConfirmButton={true}>

            <form onSubmit={handleVerification}>

                <p>Please get the 6-digit verification code from the citizen to resolve this complaint.</p>

                <input

                    type="text"

                    value={code}

                    onChange={(e) => setCode(e.target.value)}

                    maxLength="6"

                    placeholder="Enter 6-digit Code"

                    required

                    disabled={verifying}

                    style={{ padding: '10px', width: '100%', marginBottom: '15px', fontSize: '1.2em', textAlign: 'center' }}

                />

                <button type="submit" disabled={verifying} style={buttonStyle('resolved')}>

                    {verifying ? 'Verifying...' : 'VERIFY & RESOLVE'}

                </button>

            </form>

        </Modal>

    );

};

// --- End of Verification Modal Component ---





const AgentComplaintDetailsPage = () => {

    const { auth } = useContext(AuthContext);

    const { id } = useParams();

    const [complaint, setComplaint] = useState(null);

    const [loading, setLoading] = useState(true);

    const [statusUpdating, setStatusUpdating] = useState(false);



    const [currentLocation, setCurrentLocation] = useState(null); // Live location state

    const [isVerificationModalOpen, setVerificationModalOpen] = useState(false); // NEW STATE for Modal

    const [isConfirmModalOpen, setConfirmModalOpen] = useState(false);

    const [isTracking, setIsTracking] = useState(false); // Kya tracking chalu hai?

    const watchIdRef = useRef(null); // watchPosition ki

    const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };







    // --- 1. Fetch Complaint Details (Agent API) ---

    useEffect(() => {

        const fetchDetails = async () => {

            if (!auth.token || !id) { setLoading(false); return; }

            try {

                const response = await axios.get(`${API_BASE_URL}/agent/complaints/${id}`, config);

                setComplaint(response.data);

            } catch (error) {

                console.error("Failed to fetch complaint details:", error);

                toast.error(`Error loading complaint ${id}.`);

            } finally { setLoading(false); }

        };

        fetchDetails();

    }, [auth.token, id]);



    // --- 2. Live Location Fetcher ---

    useEffect(() => {

        if ("geolocation" in navigator) {

            // Location fetch karne ki koshish karo

            navigator.geolocation.getCurrentPosition(

                (position) => {

                    // Success: Location mil gayi to state mein save kar lo

                    setCurrentLocation({

                        lat: position.coords.latitude,

                        lng: position.coords.longitude

                    });

                    toast.success("Live location fetched!");

                },

                (error) => {

                    // Error: Agar location nahi mili

                    console.error("Error getting live location:", error);

                    setCurrentLocation(false); // State mein false set kar do

                    toast.error("Could not get your location. Please check browser permission and move to an open area.");

                },

                {

                    enableHighAccuracy: true,

                    timeout: 15000, // Timeout badha kar 15 seconds kar diya

                    maximumAge: 0

                }

            );

        } else {

            // Agar browser mein location feature hi nahi hai

            setCurrentLocation(false);

            toast.error("Geolocation is not supported by this browser.");

        }

    }, []); // Yeh useEffect sirf component load hone par ek baar chalega



    // --- 3. Navigation Handler (Combines location check & URL fix) ---

    const handleNavigate = () => {

        if (!complaint || !complaint.latitude || !complaint.longitude) {

            toast.error("Complaint location is missing.");

            return;

        }



        const destination = `${complaint.latitude},${complaint.longitude}`;

        let navigationUrl;



        // Check karo ki state mein live location hai ya nahi

        if (currentLocation && currentLocation.lat && currentLocation.lng) {

            const source = `${currentLocation.lat},${currentLocation.lng}`;



            // --- YEH HAI 100% SAHI GOOGLE MAPS URL ---

            navigationUrl = `https://www.google.com/maps/dir/?api=1&origin=${source}&destination=${destination}`;



            window.open(navigationUrl, "_blank"); // Naye tab mein URL khol do



        } else {

            // Agar live location nahi mili to user ko batao

            toast.error("Your live location is not available. Please try again after some time.");

            // Fallback: Sirf complaint ki location map par dikha do

            navigationUrl = `http://googleusercontent.com/maps.google.com/search/?api=1&query=${destination}`;



        }

        window.open(navigationUrl, "_blank");

    };



    // --- 4. Code Generation & Status Change Handler ---

    const handleCodeGeneration = async (currentStatus) => {



        setConfirmModalOpen(true);

    };



    const updateLocationAPI = async (latitude, longitude) => {

        if (!auth.token) return;

        try {

            const config = { headers: { 'Authorization': `Bearer ${auth.token}` } };

            await axios.put(`${API_BASE_URL}/agent/location`, { latitude, longitude }, config);

            console.log('Location updated:', latitude, longitude); // Log kar sakte hain

        } catch (error) {

            console.error("Failed to update location via API:", error);

            // Yahan toast dikha sakte hain agar zaroori ho

        }

    };



    // Function jo location tracking shuru karega

    const startTracking = () => {

        if (!("geolocation" in navigator)) {

            toast.error("Geolocation is not supported by your browser.");

            return;

        }



        setIsTracking(true);

        toast.success("Live location tracking started!");



        // watchPosition ko call karo aur ID save karo

        watchIdRef.current = navigator.geolocation.watchPosition(

            (position) => {

                // Har baar nayi location milne par API call karo

                const { latitude, longitude } = position.coords;

                updateLocationAPI(latitude, longitude);

            },

            (error) => {

                // Agar location fetch karne mein error aaye

                console.error("Error watching position:", error);

                toast.error(`Location tracking error: ${error.message}`);

                stopTracking(); // Tracking band kar do

            },

            {

                enableHighAccuracy: true, // Best possible location

                timeout: 10000,          // 10 second timeout

                maximumAge: 0,           // Hamesha nayi location chahiye

                distanceFilter: 10       // Location tabhi update hogi jab agent 10 meter move karega (optional)

            }

        );

    };



    // Function jo location tracking band karega

    const stopTracking = () => {

        if (watchIdRef.current !== null) {

            navigator.geolocation.clearWatch(watchIdRef.current);

            watchIdRef.current = null; // ID ko reset karo

            setIsTracking(false);

            toast.info("Live location tracking stopped.");

            console.log("Tracking stopped.");

        }

    };



    useEffect(() => {

        // Yeh function tab chalega jab component screen se hatega

        return () => {

            stopTracking();

        };

    }, []);



    // --- NAYE FUNCTIONS END ---



    const confirmAndGenerateCode = async () => {

        if (statusUpdating) return;

        setStatusUpdating(true);

        setConfirmModalOpen(false); // Naye modal ko band karo



        try {

            // Yeh aapka purana logic hai

            const response = await axios.get(`${API_BASE_URL}/agent/generate-code/${complaint.id}`, config);

            toast.success("Verification code has been sent to the citizen successfully!");

            setVerificationModalOpen(true); // Purana code entry modal kholo



        } catch (error) {

            console.error("Code generation failed:", error);

            const errorMessage = error.response?.data || "Error starting verification process.";

            toast.error(errorMessage);

        } finally {

            setStatusUpdating(false);

        }

    };





    // Final handler after successful verification

    const handleVerificationSuccess = (updatedComplaint) => {

        setComplaint(updatedComplaint); // UI update karein

        setVerificationModalOpen(false);

        stopTracking();

    };



    // --- Render Logic ---

    if (loading) return <div>Loading Complaint Details...</div>;

    if (!complaint) return <div>Complaint not found or unauthorized access.</div>;



    const isResolved = complaint.status === 'Resolved';

    const isInProgress = complaint.status === 'In-Progress';

    // const isReadyToStart = complaint.status === 'New' || complaint.status === 'Assigned';

    const isAssignedOrNew = complaint.status === 'Assigned' || complaint.status === 'New';



    return (

        <div style={{ padding: '20px' }}>

            <h1>Complaint Details: {complaint.ticketId}</h1>

            <div style={{ padding: '15px', border: '1px solid #ccc', borderRadius: '8px' }}>

                <p><strong>Category:</strong> {complaint.category}</p>

                <p><strong>Description:</strong> {complaint.description}</p>

                <p><strong>Location:</strong> {complaint.location} (Landmark: {complaint.landmark})</p>

                <p><strong>Citizen Email:</strong> {complaint.citizen?.email}</p>



                {/* Navigation Button */}

                <div style={{ marginTop: '15px', marginBottom: '15px' }}>

                    <button

                        onClick={handleNavigate}

                        disabled={!complaint.latitude}

                        style={{ ...buttonStyle('navigate'), backgroundColor: '#007bff', color: 'white' }}

                    >

                        <FiMap style={{ marginRight: '5px' }} /> Navigate from Live Location

                    </button>

                    {currentLocation === false && (

                        <p style={{ color: 'red', fontSize: '0.9em' }}>Could not fetch your live location. Map will show complaint destination only.</p>

                    )}

                    {(complaint.status === 'Assigned' || complaint.status === 'In-Progress') && (

                        isTracking ? (

                            // Agar tracking chalu hai, to Stop button dikhao

                            <Button

                                variant="contained"

                                color="error"

                                onClick={stopTracking}

                                startIcon={<FiStopCircle />}

                            >

                                Stop Tracking

                            </Button>

                        ) : (

                            // Agar tracking band hai, to Start button dikhao

                            <Button

                                variant="contained"

                                color="success"

                                onClick={startTracking}

                                startIcon={<FiPlayCircle />}

                            >

                                Start Journey

                            </Button>

                        )

                    )}

                    {/* --- NAYA BUTTON LOGIC END --- */}



                    {/* ... error message ... */}



                </div>



                <hr />

                <p style={{ fontWeight: 'bold', color: isResolved ? 'green' : 'red' }}>Current Status: {complaint.status}</p>



                {/* Status Update Buttons */}

                <div style={{ marginTop: '20px' }}>

                    {/* Button A: Start Work / Get Code

                    {isReadyToStart && (

                        <button onClick={() => handleCodeGeneration(complaint.status)} disabled={statusUpdating} style={buttonStyle('progress')}>

                            {statusUpdating ? 'Starting Work...' : 'START WORK & GET CODE'}

                        </button>

                    )} */}



                    {/* Button B: Mark as Resolved (Verification Modal open karein) */}



                    {(isInProgress || isAssignedOrNew) && !isResolved && (

                        <button

                            // FIX: handleCodeGeneration ko call karein on click

                            onClick={() => handleCodeGeneration(complaint.status)}

                            disabled={statusUpdating}

                            style={buttonStyle('resolved')}

                        >

                            {statusUpdating ? 'Generating Code...' : 'MARK AS RESOLVED (Get Code)'}

                        </button>

                    )}

                    {/* {isInProgress && (

                        <button onClick={() => setVerificationModalOpen(true)} disabled={statusUpdating} style={buttonStyle('resolved')}>

                            Mark as Resolved

                        </button>

                    )} */}

                </div>

            </div>



            {/* --- Verification Modal Render --- */}

            {isVerificationModalOpen && complaint && (

                <VerificationModal

                    complaintId={complaint.id}

                    ticketId={complaint.ticketId}

                    onVerifySuccess={handleVerificationSuccess}

                    onModalClose={() => setVerificationModalOpen(false)}

                />

            )}



            {isConfirmModalOpen && (

                <Modal

                    isOpen={true}

                    onClose={() => setConfirmModalOpen(false)}

                    title="Confirm Action"

                    // Naye modal ke confirm par naya function call karo

                    onConfirm={confirmAndGenerateCode}

                    confirmText="Yes, Proceed"

                    cancelText="No, Cancel"

                >

                    <p>Are you sure you have reached the location and are ready to mark this complaint as resolved? This will generate the Citizen Verification Code.</p>

                </Modal>

            )}

        </div>

    );

};



// Inline styling for buttons

const buttonStyle = (type) => ({

    padding: '10px 15px',

    marginRight: '10px',

    backgroundColor: type === 'progress' ? '#ffc107' : type === 'resolved' ? '#28a745' : '#ccc',

    color: type === 'progress' ? '#333' : 'white',

    border: 'none',

    borderRadius: '5px',

    cursor: 'pointer',

    display: 'flex',

    alignItems: 'center'

});



export default AgentComplaintDetailsPage;